var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"basic-block lead-login",style:(_vm.styles)},[_c('div',{staticClass:"lead-login__text"},[_vm._v("占いTV月額528円(税込)")]),_vm._v(" "),_c('a',{staticClass:"lead-login__link",attrs:{"href":"/user/login"}},[_vm._v("占いTV月額会員ログインはこちら")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31dbfd27","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/recommend/lp/partials/LeadLogin.vue
// module id = null
// module chunks = 